import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../data/store'
import { creditApplicationSelectors } from '../../data/store/CreditApplicationStore'

type Props = {
  isCoapplicant?: boolean
  currentStep: number
}

function StepProgressIcon({ isCoapplicant, currentStep }: Props) {
  const { t } = useTranslation()

  const currentMerchantId = useAppSelector(creditApplicationSelectors.getCurrentMerchantId)
  const isIfinanceMerchant = currentMerchantId === Number(process.env.REACT_APP_IFINANCE_MERCHANT_ID)
  const isMedicardMerchant = currentMerchantId === Number(process.env.REACT_APP_MEDICARD_MERCHANT_ID)

  return (
    <ul className="steps">
      {!isCoapplicant && (
        <>
          <li className="loan-amount">
            <a href="step_1.html">
              <i className="fa-light fa-circle-dollar" />
              <div className="step-info">
                <p>
                  {t<string>('common.step')} {currentStep}
                </p>
                <h4>{t<string>('common.loanAmount')}</h4>
              </div>
            </a>
          </li>
          {(isIfinanceMerchant || isMedicardMerchant) && (
            <>
              <li className="loan-purpose">
                <a href="step_2.html">
                  <i className="fa-light fa-hand-holding-dollar" />
                  <div className="step-info">
                    <p>
                      {t<string>('common.step')} {currentStep}
                    </p>
                    <h4>
                      {isIfinanceMerchant ? t<string>('common.loanPurpose') : t<string>('common.serviceProvider')}
                    </h4>
                  </div>
                </a>
              </li>
              <li className="service-provider">
                <a href="step_3.html">
                  <i className="fa-light fa-briefcase" />
                  <div className="step-info">
                    <p>
                      {t<string>('common.step')} {currentStep}
                    </p>
                    <h4>{t<string>('common.serviceProvider')}</h4>
                  </div>
                </a>
              </li>
            </>
          )}
        </>
      )}
      <li className="personal-information">
        <a href="step_4.html">
          <i className="fa-light fa-circle-user" />
          <div className="step-info">
            <p>
              {t<string>('common.step')} {currentStep}
            </p>
            <h4>{isCoapplicant ? t<string>('common.aboutCoapplicant') : t<string>('common.aboutYourself')}</h4>
          </div>
        </a>
      </li>
      <li className="contact">
        <a href="step_5.html">
          <i className="fa-light fa-id-card" />
          <div className="step-info">
            <p>
              {t<string>('common.step')} {currentStep}
            </p>
            <h4>{t<string>('common.contactInfo')}</h4>
          </div>
        </a>
      </li>
      <li className="address">
        <a href="step_6.html">
          <i className="fa-light fa-map-location-dot" />
          <div className="step-info">
            <p>
              {t<string>('common.step')} {currentStep}
            </p>
            <h4>{t<string>('common.yourHome')}</h4>
          </div>
        </a>
      </li>
      <li className="employment">
        <a href="step_7.html">
          <i className="fa-light fa-money-check-dollar-pen" />
          <div className="step-info">
            <p>
              {t<string>('common.step')} {currentStep}
            </p>
            <h4>{t<string>('common.annualIncome')}</h4>
          </div>
        </a>
      </li>
      <li className="recap">
        <a href="step_8.html">
          <i className="fa-light fa-clipboard-list-check" />
          <div className="step-info">
            <p>
              {t<string>('common.step')} {currentStep}
            </p>
            <h4>{t<string>('common.review')}</h4>
          </div>
        </a>
      </li>
    </ul>
  )
}

StepProgressIcon.defaultProps = {
  isCoapplicant: false,
}

export default StepProgressIcon
